// extracted by mini-css-extract-plugin
module.exports = {"Detail_Response":"DetailResponse_Detail_Response__J4RPr"};